import React from 'react';
import moment from 'moment-timezone';
import { DateBadgeComponent as DateBadge } from '@views/Timeline/components/DateBadge.component';
import { fontWeightEnum, Text, textVariantsEnum } from '@/components/Text';
import { formatPercent } from '@/utils/numberUtils';
import { formatTimeFromSeconds } from '@/utils/timeUtils';
import styles from './DayGroupHeader.module.scss';

export const DayGroupHeaderComponent = ({ dayKey, dayLabel, totals }) => {
  const date = moment(dayKey, 'YYYY-MM-DD');
  const isToday = moment().format('YYYY-MM-DD') === dayKey;
  const isYesterday =
    moment().subtract(1, 'day').format('YYYY-MM-DD') === dayKey;
  const labelPrefix = isToday ? 'Today, ' : isYesterday ? 'Yesterday, ' : '';

  return (
    <div className={styles.dayGroupHeader}>
      <DateBadge date={date} colorIndex={date.dayOfYear()} />
      <div className={styles.headingText}>
        <Text
          variant={textVariantsEnum.Display_xs}
          fontWeight={fontWeightEnum.Semibold}
          color="gray-900"
        >
          {labelPrefix}
          {dayLabel}
        </Text>
        {totals && (
          <Text
            variant={textVariantsEnum.Text_sm}
            fontWeight={fontWeightEnum.Normal}
            color="gray-500"
          >
            {`Total: ${formatTimeFromSeconds(totals.durationSec)}`}
            <span className={styles.summaryDivider}>•</span>
            {`Idle: ${formatTimeFromSeconds(totals.idleSec)}`}
            <span className={styles.summaryDivider}>•</span>
            {`Activity: ${formatPercent(totals.activityPct)}`}
          </Text>
        )}
      </div>
    </div>
  );
};

DayGroupHeaderComponent.displayName = 'DayGroupHeader';
